import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { Image, SharingPopup } from 'C4';

const Collection = (props) => {
  const { content } = props;
  const header = content[0].chapter.chapterTitle;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(content).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = {
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'y',
    },
    buttons: ['thumbs', 'share', 'download', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={window.location.href} />),
    },
    caption: header,
  };

  return (
    <div className="collection__Container">
      <div className="collection__Container--title">
        <h3>{header}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="collection__Grid">
            {Object.values(content).map((item, index) => {
              const {
                pageID, image, title, url, type,
              } = item;
              if (type === 'pdf') {
                  return (
                    <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                      <Image
                        key={url}
                        src={image}
                        gradient
                        onLoad={() => { this.setState({ loading: false }); }}
                        href={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                        fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                        options={fancyOptions}
                        caption={title}
                      />
                      <div className="title">{title}</div>
                    </div>
                  );
              }

              return (
                <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <Image
                      key={url}
                      src={image}
                      caption={title}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                    />
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default Collection;

Collection.propTypes = {
  content: PropTypes.arrayOf.isRequired,
};
